import React from 'react';
import Config from "../../../../dev/config/main";
import moment from "moment";
import {t} from "../../../../dev/helpers/translator";

export default function gameInfoTemplate () {
    let { game, showType } = this.props,
        { statisticsOpened } = this.state,
        conf = Config.main,
        gameTime = conf.changeTimeZoneByUTC ? moment.unix(game.start_ts).utcOffset(conf.changeTimeZoneByUTC).format(conf.timeFormat) : moment.unix(game.start_ts).format(conf.timeFormat);
    return (
        <div className="game-view-wrapper prematch-v">
            <div className={"game-view-title-contain-m" + (game.team2_name ? "" : " single-team")}>
                <div className="game-date-row-m">
                    <p>{moment.unix(game.start_ts).format(conf.dateFormat)}</p>
                    {game.is_stat_available
                        ? <div className={`statistic-icon-view-m ${statisticsOpened ? "active" : ""}`} onClick={Config.terminal.disabledAutoOpenGameStatistics ? this.openStatistics(game.id) : null }>
                            <b>
                                <span className="statistic-icon-m-v"/>
                            </b>
                        </div> : null}
                    <span>{gameTime}</span>
                </div>
                <div className="teams-name-shirt-color">
                    <ul>
                        <li className="team-names-b-m">
                            <p>{game.team1_name}</p>
                            {game.info.shirt1_color && game.team2_name && showType !== "OUTRIGHT" ? <div className="shirt-box-m"/> : null }
                        </li>
                        {game.team2_name
                            ? [
                                <li className="vs-contain-m" key="vs">
                                    <span>{t("vs")}</span>
                                </li>,
                                <li className="team-names-b-m" key="team2">
                                    <p>{game.team2_name}</p>
                                    {game.info.shirt2_color ? <div className="shirt-box-m"/> : null }
                                </li>
                            ] : null}
                    </ul>
                    {game.info.add_info ? <div className="game-view-additional-info-m"><p>{game.info.add_info}</p></div> : null}
                </div>
            </div>
        </div>
    );
};
